export function meterPercent(value: number, max: number): number {
  if (max <= 0) return 0;
  return Math.min(100, Math.max(0, (value / max) * 100));
}

export function previousMeterValue(current: number, delta?: string): number | undefined {
  if (!delta) return undefined;
  const amount = Number(delta);
  if (!Number.isFinite(amount)) return undefined;
  return current - amount;
}
